
<div  class="val-barre-navigation-item val-flex-conteneur val-flex-colonne val-couleur-texte">
  <div  class="val-barre-navigation-item-entete val-flex-conteneur"
        [ngClass]="{'val-barre-navigation-item-entete-selectionnee': donneesItem.selectionne}"
        [title]="!barreNavigation.ouvert && donneesItem.libelle ? (donneesItem.libelle | val_libelle_dico: donneesItem.dico) : ''"
        (click)="EnteteClick()"
        (mouseenter)="MouseEnter()"
        (mouseleave)="MouseLeave()">
    @if (donneesItem.iconeClass) 
    {
      <val-fonte-icone  class="val-barre-navigation-item-icone"
                        [iconeCss]="donneesItem.iconeClass">
      </val-fonte-icone>
    }
    <val-simple-libelle class="val-barre-navigation-item-libelle val-flex-1"
                        [libelle]="donneesItem.libelle | val_libelle_dico: donneesItem.dico"
                        [ngClass]="{'val-invisible': donneesItem.masque}">
    </val-simple-libelle>
    @if (groupe) 
    {
      <val-fonte-icone  class="val-barre-navigation-item-commande val-couleur-icone-action"
                        iconeCss="fas fa-chevron-right"
                        utiliserRotation="true"
                        [rotation]="donneesItem.ouvert ?? false"
                        [ngClass]="{'val-invisible': donneesItem.masque}">
      </val-fonte-icone>
    }
  </div>
  @if (groupe) 
  {
    <div  class="val-barre-navigation-item-conteneur"
          [style.--nombre-commandes]="donneesItem.commandes?.length ?? 0"
          [class.ouvert]="donneesItem.ouvert"
          [class.ferme]="!donneesItem.ouvert"
          [ngClass]="{'val-invisible': donneesItem.masque}">
      @for (navigationItem of donneesItem.commandes; track $index)
      {
        <val-barre-navigation-item  [barreNavigation]="barreNavigation"
                                    [donneesItemGroupe]="donneesItem"
                                    [donneesItem]="navigationItem">
        </val-barre-navigation-item>
      }
    </div>
  }
  <div  #popUp
        class="val-barre-navigation-popup val-flex-conteneur" 
        [ngStyle]="{'width': barreNavigation.largeur + 'px'}"
        (mouseenter)="PopUpMouseEnter()"
        (mouseleave)="PopUpMouseLeave()">
    <div class="val-barre-navigation-popup-marge"></div>
    <div class="val-flex-1">
      <div  class="val-barre-navigation-popup-entete val-couleur-fond"
            [ngClass]="{'val-barre-navigation-popup-entete-selectionnee': donneesItem.selectionne}">
        <val-simple-libelle [libelle]="donneesItem.libelle | val_libelle_dico: donneesItem.dico"></val-simple-libelle>
      </div>
      <div #popUpConteneur class="val-barre-navigation-popup-conteneur val-flex-1">
        @if (donneesItem.commandes && donneesItem.commandes.length > 0)
        {
          @for (navigationItem of donneesItem.commandes; track $index)
          {
            <val-barre-navigation-item  [barreNavigation]="barreNavigation"
                                        [donneesItemGroupe]="donneesItem"
                                        [itemGroupe]="this"
                                        [donneesItem]="navigationItem">
            </val-barre-navigation-item>
          }
        }
      </div>
    </div>
  </div>
</div>

